"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = require("vue");

var getDistance = function getDistance(p1, p2) {
  var x = p2.pageX - p1.pageX,
      y = p2.pageY - p1.pageY;
  return Math.sqrt(x * x + y * y);
};

var getAngle = function getAngle(p1, p2) {
  var x = p1.pageX - p2.pageX,
      y = p1.pageY - p2.pageY;
  return Math.atan2(y, x) * 180 / Math.PI;
};

var _default = function _default(dom, gestureEvent) {
  var gesturestart = new CustomEvent('gesturestart');
  var gesturechange = new CustomEvent('gesturechange');
  var gestureend = new CustomEvent('gestureend');
  var gestureDom = (0, _vue.computed)(function () {
    var _dom = dom;

    if (dom.hasOwnProperty('value') || dom.hasOwnProperty('_value')) {
      _dom = dom.value;
    }

    return _dom;
  });
  var istouch = false;
  var start = [];

  var touchstart = function touchstart(e) {
    if (e.touches.length >= 2) {
      //判断是否有两个点在屏幕上
      istouch = true;
      start = e.touches; //得到第一组两个点

      gestureDom.value.dispatchEvent(gesturestart);
    }
  };

  var touchmove = function touchmove(e) {
    if (e.touches.length >= 2 && istouch) {
      e.preventDefault();
      var now = e.touches; //得到第二组两个点

      var scale = getDistance(now[0], now[1]) / getDistance(start[0], start[1]); //得到缩放比例

      var rotation = getAngle(now[0], now[1]) - getAngle(start[0], start[1]); //得到旋转角度差

      gesturechange.scale = scale.toFixed(2);
      gesturechange.rotation = rotation.toFixed(2);
      gestureDom.value.dispatchEvent(gesturechange);
    }
  };

  var touchend = function touchend() {
    if (istouch) {
      istouch = false;
      gestureDom.value.dispatchEvent(gestureend);
    }
  };

  var initGestureEvent = function initGestureEvent() {
    if (gestureDom.value) {
      gestureDom.value.addEventListener('touchstart', touchstart);
      gestureDom.value.addEventListener('touchmove', touchmove);
      gestureDom.value.addEventListener('touchend', touchend);
      gestureEvent.gesturestart && gestureDom.value.addEventListener('gesturestart', gestureEvent.gesturestart);
      gestureEvent.gesturechange && gestureDom.value.addEventListener('gesturechange', gestureEvent.gesturechange);
      gestureEvent.gestureend && gestureDom.value.addEventListener('gestureend', gestureEvent.gestureend);
    } else {
      console.log('geture event init failed');
    }
  };

  var destroyGestureEvent = function destroyGestureEvent() {
    if (gestureDom.value) {
      gestureDom.value.removeEventListener('touchstart', touchstart);
      gestureDom.value.removeEventListener('touchmove', touchmove);
      gestureDom.value.removeEventListener('touchend', touchend);
      gestureEvent.gesturestart && gestureDom.value.removeEventListener('gesturestart', gestureEvent.gesturestart);
      gestureEvent.gesturechange && gestureDom.value.removeEventListener('gesturechange', gestureEvent.gesturechange);
      gestureEvent.gestureend && gestureDom.value.removeEventListener('gestureend', gestureEvent.gestureend);
    } else {
      console.warn('geture event no find gestureDom,can"t destory gesture');
    }
  };

  return {
    initGestureEvent: initGestureEvent,
    destroyGestureEvent: destroyGestureEvent
  };
};

exports.default = _default;